<template>
  <div class="dashboard-style">
    <div class="card">
      <div class="card-body">
        <div class="containerFormular">
          <div class="headline-text">
            Verfügbare Artikel hochladen
          </div>
          <div align="center">
            <h5> Hier finden Sie Ihre Artikel. </h5>
            <div class="containerFormular">
              <ArticleListItem
                v-for="(item, index) in retailerItems"
                :key="item.id"
                :item="item"
                :ean="item.ean"
                :price="item.price"
                @click="deleteItem(item.ean, index)"
              />
            </div>
          </div>
          <notifications
            group="list-notifications"
            position="center bottom"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import ArticleListItem from "./ArticleListItem";
    import firebase from "firebase";

    export default {
        name: "RetailerArticleOverview",
        components: {
            ArticleListItem
        },
        data() {
            return {
                retailerItems: [],
                currentItemId: 0
            }
        },
        created () {
            // fetch the data
            this.fetchData();
        },
        methods: {
            async deleteItem(ean, index) {
                const vm = this;
                const userId = firebase.auth().currentUser.uid;
                try{
                    await firebase.database().ref('/retailer/' + userId + "/productrange/" + ean).remove();
                    vm.retailerItems.splice(index, 1);
                    // this.retailerItems = this.retailerItems.filter((item) => item.ean !== ean);
                    this.$notify({
                        group: 'list-notifications',
                        title: 'Erfolg!',
                        text: `Artikel ${ean} wurde gelöscht.`,
                        type: 'success',
                        duration: 5000,
                    });
                } catch(e) {
                    this.$notify({
                        group: 'list-notifications',
                        title: 'Fehler!',
                        text: `Es gab einen Fehler: ${e.message}`,
                        type: 'error',
                        duration: 5000,
                    });
                }
            },
            fetchData() {
                const vm = this;
                const userId = firebase.auth().currentUser.uid;
                try {
                    const productRangeRef = firebase.database().ref("retailer/" + userId + "/productrange/");
                    productRangeRef.once('value', function(snapshot) {
                        snapshot.forEach(function(childSnapshot) {
                            const childKey = childSnapshot.key;
                            const childData = childSnapshot.val();
                            vm.retailerItems.push({
                                id: ++vm.currentItemId,
                                ean: childKey,
                                price: childData.price
                            })
                        });
                    });
                } catch (e) {
                    this.$notify({
                        group: 'list-notifications',
                        title: 'Fehler!',
                        text: `Es gab einen Fehler beim Abrufen der Artikel: ${e.message}`,
                        type: 'error',
                        duration: 5000,
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>